import { render } from "./RequestsView.vue?vue&type=template&id=69c1162c&scoped=true"
import script from "./RequestsView.vue?vue&type=script&lang=js"
export * from "./RequestsView.vue?vue&type=script&lang=js"

import "./RequestsView.css?vue&type=style&index=0&id=69c1162c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c1162c"]])

export default __exports__